
const game2Config = {
    time: 3500
}

export default game2Config;